export default __webpack_public_path__ + "static/media/banana.e914a250.gif";